export default class ContactDetail {
    constructor() {

        this.id = 0;
        this.title = '';
        this.firstName = '';
        this.lastName = '';
        this.phone = '';
        this.email = '';
        this.department = '';
        this.value = '';
        this.newContactSaved = false;

    }
}
